import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { getSmartLinkDetail } from 'Shared/actions/smart_links';

import './SmartMenu.scss';
import WpPopover, { WpPopoverBody, WpPopoverHeader } from 'Wpds/components/popover-v1/WpPopover';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import Spinner from 'Shared/components/Spinner';

type Props = {
  href: string;
  isLoggedIn: boolean;
  hasDocumentIntegration: boolean;
  smart_link_detail: {
    uuid: string;
    loading: boolean;
  };
  objectName: string;
  onGetSmartLinkDetail: Function;
  renderSmartLinkDetail: Function;
  renderEmbedingContent: Function;
  renderSmartLinkBadge?: Function;
  menuTitle?: Function;
  children?: React.ReactNode;
};

type State = {
  isDropdownOpen: boolean;
};

class SmartMenu extends Component<Props, State> {
  tooltipRef = React.createRef();
  buttonRef = React.createRef<HTMLDivElement>();

  state = { isDropdownOpen: false };

  handleDropDownToggle = event => {
    event.stopPropagation();
    const { isDropdownOpen } = this.state;
    const { isLoggedIn, smart_link_detail, onGetSmartLinkDetail, href } = this.props;
    if (!isDropdownOpen && isLoggedIn && (!smart_link_detail || !smart_link_detail.uuid))
      onGetSmartLinkDetail({ url: href });
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }));
  };

  handleShowPopOver = () => {
    const { isLoggedIn, smart_link_detail, onGetSmartLinkDetail, href } = this.props;
    if (isLoggedIn && (!smart_link_detail || !smart_link_detail.uuid)) onGetSmartLinkDetail({ url: href });
  };

  componentDidMount() {
    const { renderSmartLinkBadge, href, onGetSmartLinkDetail, hasDocumentIntegration } = this.props;
    if (renderSmartLinkBadge && hasDocumentIntegration) {
      onGetSmartLinkDetail({ url: href });
    }
  }

  // We cannot use a local textarea because draftjs is intercepting the focus
  // so we append a textarea to the body to bypass this issue.
  handleCopyLink = () => {
    const { href } = this.props;

    const el = document.createElement('textarea');
    el.value = href;
    el.setAttribute('readonly', '');
    el.setAttribute('style', 'position: absolute, left: -9999px; height: 0; width: 0;');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  render() {
    const {
      smart_link_detail,
      hasDocumentIntegration,
      renderEmbedingContent,
      renderSmartLinkDetail,
      renderSmartLinkBadge,
      objectName,
      menuTitle,
      children,
    } = this.props;
    const className = 'SmartMenu';
    const popoverTitle =
      menuTitle && smart_link_detail && !smart_link_detail.loading ? menuTitle(smart_link_detail) : objectName;
    return (
      <div className={className} ref={this.buttonRef}>
        {children && <>{children}</>}
        {renderSmartLinkBadge && smart_link_detail && !smart_link_detail.loading && smart_link_detail.uuid && (
          <>
            {renderSmartLinkBadge(smart_link_detail) && (
              <div className={`${className}__badge`}>{renderSmartLinkBadge(smart_link_detail)}</div>
            )}
          </>
        )}
        {!children && (
          <WpButton size="sm" variant="tertiary">
            <WpIcon name="ellipsis-h-alt" />
          </WpButton>
        )}
        <WpPopover target={this.buttonRef} placement="bottom" onShow={this.handleShowPopOver}>
          {hasDocumentIntegration && (
            <div className={`${className}__header`}>
              <WpPopoverHeader centered>{popoverTitle}</WpPopoverHeader>
            </div>
          )}
          <WpPopoverBody>
            {hasDocumentIntegration ? (
              <div className={`${className}__content`}>
                {smart_link_detail &&
                  !smart_link_detail.loading &&
                  smart_link_detail.uuid &&
                  renderSmartLinkDetail(smart_link_detail)}
                {smart_link_detail && smart_link_detail.loading && (
                  <div>
                    <Spinner activeIf />
                    We&apos;re retrieving information on this {objectName}
                  </div>
                )}
                {smart_link_detail && !smart_link_detail.loading && !smart_link_detail.uuid && (
                  <div>We couldn&apos;t find any information on this {objectName}</div>
                )}
              </div>
            ) : (
              renderEmbedingContent()
            )}
          </WpPopoverBody>
        </WpPopover>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { entityKey, contentState } = ownProps;
  const { href } = contentState.getEntity(entityKey).getData();
  return {
    href,
    smart_link_detail: state.smart_links.find(smart_link => smart_link.url === href),
    isLoggedIn: get(state.user, 'isLoggedIn', false),
  };
};

const mapDispatchToProps = dispatch => ({
  onGetSmartLinkDetail: params => dispatch(getSmartLinkDetail(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartMenu);
